import React from 'react'
import { Link } from 'react-router-dom'

class Completed extends React.Component {
    render() {
        return (
            <React.Fragment>
                <p className="login-box-heading">{this.props.title}</p>
                <p className="text-center">{this.props.message}</p>
                <hr />
                <div className="login-box-links text-center">
					<Link id="lnkGoToLogin" to="/public/login" className="btn btn-primary btn-flat">Go to login</Link>
                </div>
            </React.Fragment>
        );
    }
}

export default Completed;



// WEBPACK FOOTER //
// ./src/layouts/public/completed/Completed.js